import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { GdpSprintService } from '../services/gdp-sprint.service';

/**
 * Redirige las rutas antiguas /gdp/sprints/:sprintId/{plan|board} a las
 * nuevas /gdp/projects/:projectId/sprints/:sprintId/{plan|board}: carga el
 * sprint para conocer su proyecto y devuelve el UrlTree destino (conservando
 * los query params, p. ej. el deep link ?task= del tablero).
 */
export const legacySprintRedirectGuard: CanActivateFn = route => {
  const router = inject(Router);
  const sprintService = inject(GdpSprintService);
  const sprintId = Number(route.paramMap.get('sprintId'));
  const view = route.url[route.url.length - 1]?.path === 'board' ? 'board' : 'plan';
  if (!Number.isFinite(sprintId) || sprintId <= 0) {
    return router.createUrlTree(['/gdp']);
  }
  return sprintService.getSprint(sprintId).pipe(
    map(sprint => router.createUrlTree(
      ['/gdp/projects', sprint.projectId, 'sprints', sprintId, view],
      { queryParams: route.queryParams }
    )),
    catchError(() => of(router.createUrlTree(['/gdp'])))
  );
};
